export default __webpack_public_path__ + "static/media/survivio-Ahoy_Loadout-sm.cc9442ed.gif";